import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import CategoryForm from '../../../components/forms/CategoryForm'
import Popup from '../../../components/elements/Popup'

import Types from '../../../actions/Types'
import PostAction from '../../../actions/categories/PostAction'
import ListColorsAction from '../../../actions/colors/ListAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class CreateCategoryPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      submit: null
    }

    // Bind events
    this.submit = this.submit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    this.props.fetchColors()
  }

  componentDidUpdate(prevProps, prevState) {
    // When successful, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.error
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Catégorie ajoutée.')
      this.props.onClose(true)
    }
  }

  submit() {
    if (_.isFunction(this.state.submit)) {
      this.state.submit()
    }
  }

  onSubmit(data) {
    this.props.post(data)
  }

  render() {
    return (
      <Popup
        header='Créer une catégorie'
        body={
          <CategoryForm
            data={undefined}
            onSubmit={this.onSubmit}
            onClearError={this.props.clearError}
            isLoading={false}
            isSaving={this.props.isSaving}
            registerSubmit={(submit) => { this.setState({ submit })}}
            error={this.props.error}
            colorsList={this.props.colorsList}
            colorsIsFetching={this.props.colorsIsFetching}
          />
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: () => this.props.onClose(false)
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: 'Créer',
            color: 'green',
            icon: 'checkmark',
            onClick: this.submit
          }
        ]}
        isSaving={this.props.isSaving}
      />
    )
  }
}

CreateCategoryPopup.propTypes = {
  // Properties
  onClose: PropTypes.func.isRequired,

  // Redux State
  isSaving: PropTypes.bool.isRequired,
  error: PropTypes.object,
  colorsList: PropTypes.array,
  colorsIsFetching: PropTypes.bool.isRequired,

  // Redux Actions
  post: PropTypes.func.isRequired,
  fetchColors: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    isSaving: state.entities.categories.post.isFetching,
    error: state.entities.categories.post.error,
    colorsList: state.entities.colors.list.data,
    colorsIsFetching: state.entities.colors.list.isFetching
  }),
  (dispatch) => ({
    post: (data) => (dispatch(PostAction({ data }))),
    fetchColors: () => (dispatch(ListColorsAction({}))),
    clearError: () => (dispatch(ClearErrorAction(Types.CATEGORIES.POST)))
  })
)(CreateCategoryPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/categories/CreateCategoryPopup.js